import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IntervalAggregatedSeveritiesPayload,
  IntervalAggregatedSeveritiesResponse
} from '@portal/shared/types/events.types';

@Injectable({ providedIn: 'root' })
export class EventsApiService {
  readonly #http = inject(HttpClient);

  getIntervalAggregatedEvents(
    payload: IntervalAggregatedSeveritiesPayload
  ): Observable<IntervalAggregatedSeveritiesResponse> {
    return this.#http.post<IntervalAggregatedSeveritiesResponse>('api/events/interval-aggregated-events', payload);
  }
}
